module.exports = __webpack_public_path__ + "media/contact/bgs-75220540.jpg";